import { X } from "@fg/icons";
import { describeToken, removeTokenAt, tokenizeQuery } from "@/lib/searchQuery";

/** Active search operators as removable chips (Gmail's search chips). */
export function SearchChips({ query, onChange }: { query: string; onChange: (query: string) => void }) {
    const tokens = tokenizeQuery(query);
    if (tokens.length === 0) return null;
    return (
        <div className="flex shrink-0 flex-wrap items-center gap-1.5 border-b px-3 py-2" role="group" aria-label="Active search filters">
            {tokens.map((t, i) => {
                const label = describeToken(t);
                return (
                    <span
                        key={`${i}-${label}`}
                        className="inline-flex max-w-full items-center gap-1 rounded-full border border-primary/30 bg-primary/5 py-0.5 pl-2.5 pr-1 text-xs text-foreground dark:bg-primary/15"
                    >
                        <span className="truncate">{label}</span>
                        <button
                            type="button"
                            onClick={() => onChange(removeTokenAt(query, i))}
                            aria-label={`Remove filter ${label}`}
                            title="Remove"
                            className="rounded-full p-0.5 text-muted-foreground hover:bg-accent hover:text-foreground focus:outline-none focus-visible:ring-2 focus-visible:ring-primary"
                        >
                            <X className="h-3 w-3" />
                        </button>
                    </span>
                );
            })}
            {tokens.length > 1 ? (
                <button
                    type="button"
                    onClick={() => onChange("")}
                    className="ml-1 rounded px-1 text-xs text-muted-foreground hover:text-foreground hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-primary"
                >
                    Clear all
                </button>
            ) : null}
        </div>
    );
}
